/**
 * Implements a news header which display news messages
 */
import { useState } from 'react';
import { useSelector } from 'react-redux';
import UpdatesBlock from '../../Info/CoinNews';
import LogsBlock from './LogsBlock';
import NewsBlock from './NewsBlock';
import Text from '../../../atoms/Text';
import Image from '../../../atoms/Image';
import { IStore } from '../../../reducers';
import backIcon from '../../../assets/images/arrow_left.svg';

import './styles.scss';

const modes = [
  {
    name: 'Logs',
    amount: undefined,
  },
  {
    name: 'News',
    amount: undefined,
  },
  {
    name: 'Updates',
    amount: 10,
  },
];

interface INewsProps {
  onBack(): void;
}

const News = ({ onBack }: INewsProps) => {
  const { items, loading } = useSelector((state: IStore) => state.news);
  const [mode, setMode] = useState('News');

  if (loading) {
    return null;
  }

  return (
    <div className='news_mobile'>
      <div className='news_mobile__header'>
        <div className='news_mobile__header__title'>
          <div className='news_mobile__header__title__back_icon'>
            <Image size='m' src={backIcon} onClick={onBack} />
          </div>
          <Text size={16} className='news_mobile__header__title__text'>
            Notifications
          </Text>
        </div>
      </div>
      <div className='news_mobile__content'>
        <div className='news_mobile__content__tabs'>
          {modes.map((item) => {
            const active = mode === item.name;
            return (
              <div
                key={item.name}
                className={`news_mobile__content__tabs__tab${
                  active ? ' news_mobile__content__tabs__tab--active' : ''
                }`}
                onClick={() => setMode(item.name)}
              >
                <Text
                  size={14}
                  className={`text--weight-600 ${
                    active ? 'text--grey-200' : 'text--grey-600'
                  }`}
                >
                  {item.name}
                </Text>
              </div>
            );
          })}
        </div>
        {mode === 'Logs' && <LogsBlock />}
        {mode === 'News' && <NewsBlock items={items} />}
        {mode === 'Updates' && <UpdatesBlock slug='KTN' />}
      </div>
    </div>
  );
};

export default News;
